import styled from 'styled-components';

import { LOAD_TEMPLATE_DROPDOWN_TEST_ID } from '../../constants';

export const Wrapper = styled.div`
    [data-testid*='${LOAD_TEMPLATE_DROPDOWN_TEST_ID}'] {
        flex: 2;
        max-height: 216px !important;
        overflow: auto;
    }
`;
